import { Button, Card, Icon } from "@/components/ui"
import { Tag } from "@/icons"
import { VARIANTS } from "@/lib/motion"
import { AnimatePresence, motion } from "motion/react"
import { useState, type ReactNode } from "react"

type CouponAddRowProps = {
  /** The field to open, given how to close it. */
  form: (close: () => void) => ReactNode
}

/** The quiet "Tenho um cupom" row that opens into the coupon field. */
export function CouponAddRow({ form }: CouponAddRowProps) {
  const [open, setOpen] = useState(false)
  const close = () => setOpen(false)
  return (
    <AnimatePresence mode="wait" initial={false}>
      {open ? (
        <motion.div key="form" variants={VARIANTS.fadeUp} initial="hidden" animate="visible" exit="exit">
          <Card variant="outline" emphasis="faint" padding="sm">
            {form(close)}
          </Card>
        </motion.div>
      ) : (
        <motion.div key="ask" variants={VARIANTS.fadeUp} initial="hidden" animate="visible" exit="exit">
          <Button variant="dashed-soft" tone="neutral" size="md" weight="semibold" fullWidth align="start" onClick={() => setOpen(true)}>
            <Icon as={Tag} size="md" tone="primary" weight="fill" />
            Tenho um cupom
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
